import defaultStates, { defaultLifeCycle, states } from '@/constants/lifecycle';

const tokenActions = {
  UPDATE_ACTIVE_TOKEN_PROPERTIES: 'UPDATE_ACTIVE_TOKEN_PROPERTIES',
  TOGGLE_TOKEN_SELECTED: 'TOGGLE_TOKEN_SELECTED',
  TOGGLE_TOKENS_SELECTED: 'TOGGLE_TOKENS_SELECTED',
  FETCH_TOKENS: 'FETCH_TOKENS',
  UPDATE_TOKENS_FILTER: 'UPDATE_TOKENS_FILTER',
  UPDATE_TOKENS_FLAGS: 'UPDATE_TOKENS_FLAGS',
  SHOW_TOKENS: 'SHOW_TOKENS',
  SHOW_TOKENS_ERROR: 'SHOW_TOKENS_ERROR',
  REFRESH_TOKENS: 'REFRESH_TOKENS',
  SHOW_SAVE_TOKEN: 'SHOW_SAVE_TOKEN',
  HIDE_SAVE_TOKEN: 'HIDE_SAVE_TOKEN',
  CREATE_TOKEN: 'CREATE_TOKEN',
  NEW_TOKEN: 'NEW_TOKEN',
  NEW_TOKEN_ERROR: 'NEW_TOKEN_ERROR',
  CLOSE_TOKENS: 'CLOSE_TOKENS',
  SHOW_DELETE_TOKEN: 'SHOW_DELETE_TOKEN',
  SHOW_DELETE_TOKENS: 'SHOW_DELETE_TOKENS',
  HIDE_DELETE_TOKEN: 'HIDE_DELETE_TOKEN',
  SHOW_DISABLE_TOKEN: 'SHOW_DISABLE_TOKEN',
  SHOW_DISABLE_TOKENS: 'SHOW_DISABLE_TOKENS',
  HIDE_DISABLE_TOKEN: 'HIDE_DISABLE_TOKEN',
  DELETE_TOKEN: 'DELETE_TOKEN',
  DESTROY_TOKEN: 'DESTROY_TOKEN',
  DESTROY_TOKEN_ERROR: 'DESTROY_TOKEN_ERROR',
  DISABLE_TOKEN: 'DISABLE_TOKEN',
  DISABLE_TOKEN_SUCCESS: 'DISABLE_TOKEN_SUCCESS',
  DISABLE_TOKEN_ERROR: 'DISABLE_TOKEN_ERROR',
};

export const tokenLists = ['all', 'admin', 'batch'];

export const tokenCategories = [...tokenLists];

export const tokenLifeCycle = [
  ...defaultLifeCycle,
  'disableStatus',
  'disableErrors',
];

export const tokenStatus = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
};

export const tokenStates = {
  ...defaultStates,
  disableStatus: states.NONE,
  disableErrors: [],
};

export default tokenActions;
